import api from './axiosConfig';

export const getPageTitleImage = async () => {
    try {
        const response = await api.get('PageTitle/image/');
        return response.data;
    } catch (error) {
        console.error('Error fetching page title image:', error);
        throw error;
    }
};